var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaeLogoPurple60(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 144",
    style: {
      enableBackground: "new 0 0 450 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#934DFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.79,10.44l-48.86,92.28L94.55,10.44H69.29l31.2,59.59l-18.16,32.69L33.8,10.44H8.71L70.78,125.5 c2.48,4.46,6.27,6.6,10.89,6.6c4.29,0,8.42-2.15,10.73-6.6l18.65-35.16l18.49,35.16c2.31,4.46,6.27,6.6,10.73,6.6 c4.46,0,8.42-2.15,10.89-6.6l62.07-115.06H189.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.21,110.96V31.4h86.33V10.44h-96.41c-5.92,0-10.73,4.8-10.73,10.73V121.2c0,5.92,4.8,10.73,10.73,10.73 h96.57v-20.96H354.21z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.56,
    y: 62.32,
    className: "st0",
    width: 55.34,
    height: 17.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.62,10.34c-4.62,0-7.76,2.64-10.23,6.77l-69,114.89h57.26v-17.66h-22.88l44.03-74.45l44.3,74.45h-22.83 V132h58.59L260.69,17.1C258.22,12.98,255.25,10.34,250.62,10.34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaeLogoPurple60);
export default __webpack_public_path__ + "static/media/WAE_logo_Purple_60.f39114bc13b26019af336dbf07a81079.svg";
export { ForwardRef as ReactComponent };